import { render, staticRenderFns } from "./configLogo.vue?vue&type=template&id=15e5db06&scoped=true&"
import script from "./configLogo.vue?vue&type=script&lang=js&"
export * from "./configLogo.vue?vue&type=script&lang=js&"
import style0 from "./configLogo.vue?vue&type=style&index=0&id=15e5db06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e5db06",
  null
  
)

export default component.exports